import type { GetCampaigns } from '@/pages/app/campaigns/types'
import { api } from '@/services/axios'

export async function getCampaignsById(rifaId: number): Promise<GetCampaigns> {
  const response = await api.get<GetCampaigns>(`Campanha/GetById/${rifaId}`)

  return response.data
}
